import React from "react";
import classes from "./Entity.module.css";

const Entity = (props) => {
  // console.log("props", props);
  return (
    <div
      className={[classes.entity, classes.gridContainer, props.className].join(
        " ",
      )}
    >
      <div className={classes.icon}>
        {props.icon && (
          <img src={props.icon} alt={`icon-${props.content}`} width="32px" />
        )}
      </div>
      <div className={classes.content}>
        {props.content}
        <span
          style={{
            fontSize: "12px",
            position: "absolute",
            bottom: "-14px",
          }}
        >
          {props.date}
        </span>
      </div>
      <div className={classes.value} style={props.styleValue}>
        {props.value}
      </div>
    </div>
  );
};

export default Entity;
